import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import Style from '../common/css/HawkSoftStyle.module.scss';
import { isStaging } from '../../utils/constant';

const Layout = ({ children, isNavbar }) => {
    const IS_STAGING = isStaging();
    const stagingOffset = IS_STAGING ? 25 : 0;  // Height of staging bar
    
    return (
        <div className={`${Style.layout} ${!isNavbar && Style.mainContent}`} style={!isNavbar ? { paddingTop: `${72.81 + stagingOffset}px` } : {}}>
            <div className={`${Style.container}`}>
                {children}
            </div>
        </div>
    );
};

export default Layout;